<template>
    <section class="content-section  pt-50"
        style="padding-bottom: 0px; padding-top: 0px !important;justify-content: center!important;" >
        <div class="container">
            <div class="row">
                <div class="col-12 pd-13" style="padding-top: 0px;">
                    <div class="section-title mb-25" style="margin-bottom: 0px;">
                        <!--  <h6>
Show Times </h6> -->
                        <h2 style="padding-top: 0px !important; ">Show Times</h2>



                        <DatePicker :totalPages="lastPage" :currentPage="currentPage" @pagechanged="onPageChange" :dates="datePages">
            </DatePicker>





                        <div  style="background-color: #eeeeeec2;padding-bottom: 15px;
margin-top: 20px;
border-radius: 5px;
width: 100%;" v-for="(movie,mkey) in dateMovies" :key="mkey" >


                            <div class="col-3" style="float: left;">
                                <div class="category-thumb" style="margin-bottom: 8px;">
                                    <figure class="category-image bor8"> <img class="bor8"
                                        :src="path+movie.poster"  :alt="movie.title"  style="opacity: 1;">
                                    </figure>
                                    <div class="category-content pad-all10">

                                        <ul class="tags text-center">
                                            <li class="mar0"> </li>
                                        </ul>


                                        <div class="details">



                                        </div>
                                    </div>
                                    <!-- end category-content -->
                                </div>
                            </div>

                            <div class="col-9" style="float: left; padding-left: 0px;
padding-top: 12px;">
                                <div style="font-weight: 600;">{{movie.title}}
                                </div>
                                <div class="popcont" style="padding-bottom: 0px;">

                                    <span style="color: #252525;"><i class="fa fa-clock-o" style="padding-right: 5px;" aria-hidden="true"></i>
                                        <span class="popsubhe" v-if="movie.dur"> {{movie.dur}}</span></span>

                                    <span style="color: #252525;"><i class="fa fa-globe" style="padding-right: 5px;" aria-hidden="true"></i>
                                        <span class="popsubhe" v-if="movie.lang"> {{ getLang(Languages, movie.lang) }}  </span> </span> <span class="popsrt"
                                        style="background-color: #ff0c0c;">{{ movie.cert }}</span>

                                </div>





                                <div class="pop-p pb-8" style="color: #252525;">
                                    <span v-if="movie.dire"><b class="colye" style="color: #e30e5f;">
                                            Director : </b> {{ movie.dire }}</span><br>
                                    <span v-if="movie.cast"> <b class="colye" style="color: #e30e5f;">
                                            Cast : </b> {{ movie.cast }}
                                    </span>
                                </div>
                            </div>


                            <div style="clear: both;">

                            </div>

                            <div class="col-12" style="padding-right: 10px;" v-if="dateShows[mkey]">

                                <button  v-for="(show,skey) in dateShows[mkey]" :key="skey" @click="gotoSeatLayout(show.id,show.isonline)"
                                :style="$route.params.showid==show.id?{'background-color':'#ffff00'}:{ 'background-color': fillColor(show.booked,show.seats,show.isonline) }"
                                    style="margin-bottom: 7px;padding: 3px 6px;font-size: 10px;margin-right: 4px;color: black !important;"
                                    href="#"  :data-toggle="show.isonline == 0&&loginCode ?'':show.isonline == 0? 'modal' : 'modal'"
    :data-target="show.isonline == 0&&loginCode?'':show.isonline==0?'#largeModal22':'#smallmodal'"
                                    class="tim goScreen bg4 text-center tibtn"> <span class="linht"> {{ show.stime}} <div
                                            class="scnb"> {{show.screen}}</div>


                                        <div class="spck" style="font-size: 6px;"> {{ show.exp}} </div>

                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import { URL,UPLOADS } from '@/conf';
import DatePicker from '../Booking/MovieDetails/DatePicker.vue';
export default {
    data:()=>({
        isLoading:true,
        showtimeLoader:true,
        currentTab:0,
        showModal:false,
        warnigText:null,
        movies:[],
        allShows:[],
        dateMovies:[],
        dateShows:[],
        path:UPLOADS,
        certclass:{"U":"ce1","U/A":"ce2","A":"ce3"},
        Languages:{"1":"Malayalam",'2':"Tamil",'3':"Hindi",'4':"English",'5':"Telugu",'6':"Kannada"},
        days:{"0":"Sun","1":"Mon","2":"Tue","3":"Wed","4":"Thu","5":"Fri","6":"Sat"},
      months:{"01":"Jan","02":"Feb","03":"Mar","04":"Apr","05":"May","06":"Jun","07":"Jul","08":"Aug","09":"Sep","10":"Oct","11":"Nov","12":"Dec"},
        currentPage:0,
      lastPage:0,
        showDates:[],
      showTimes:[],
      bookedSeats:{},
      currentShowtime:[],
      datePages:{},
        locid:localStorage.getItem("locid")
    }),
    components:{DatePicker},
    methods:{
        getAllShows(){
            axios.get(URL + "allShows/1").then((response) => {
                this.allShows = response.data.result;
                this.showDates=Object.keys(response.data.result.dates);
              }).then(()=>{
                this.isLoading=false;
                this.showtimeLoader=false;
        this.populatePage();
        this.onPageChange(this.currentPage);
        this.getBooked();
              })
        },
        getBooked(){
       axios.get(URL + "seatcount/1/").then((response) => {
        for(var dt in this.allShows.showtime){
            for(var mv in this.allShows.showtime[dt]){
                for(var sh of this.allShows.showtime[dt][mv]){
                    var booked=response.data.result.booked[sh.id];
                    sh["booked"]=booked;
            }
            }
        }
        
      })
      },
        populatePage(){
        this.datePages=[];
        this.lastPage=this.showDates.length;
        for(var i=0;i<this.lastPage;i++){
         var splited=this.showDates[i].split("-");
           var pg={"day":this.days[splited[3]]+" "+splited[2],"mth":this.months[splited[1]]}
           this.datePages.push(pg); 
        }
    },
    onPageChange(page) {
      this.currentPage = page;
      var curdt=this.showDates[page];
    this.dateMovies=this.allShows.movies[curdt];
    this.dateShows=this.allShows.showtime[curdt];
    },
    gotoSeatLayout(id,isonline){
      this.showModal=isonline;
      this.$emit('getid', id)
      this.warnigText="Specified show tickets not available online.Please visit the box office!!";
      if(isonline==0){
        this.$router.push("../seatlayout/"+id);
      }
    },
  fillColor(cnt,seats,ison){
    if(ison!=0){
      return 'rgb(204,204,204)';
    }
  var blprc=cnt/seats;  
  var r = 255,
  g = Math.floor((255 * (1-blprc)));
  g=g>255?255:g;
  var b=g;
  return 'rgb('+r+','+g+','+b+')';
}
    },
    created() {
       this.getAllShows();
  },
  computed: {

getLang: () => {
  return (langs, key) => {
    return langs[key]
  }

},},
}
</script>